export enum NavbarItemId {
  Views = 'views',
  Conversations = 'conversations',
  Sites = 'sites',
  Clients = 'clients',
  Projects = 'projects',
  MyDrafts = 'my-drafts',
}

export const PLATFORM_PARTNER_HIDDEN_MENU_ITEMS: string[] = [
  NavbarItemId.Conversations,
  NavbarItemId.Sites,
  NavbarItemId.Clients,
];
